import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import Iconify from '../../../components/iconify';


function FilterField({ setSearchTerm, searchTerm, label }) {
  return (
    <TextField
      fullWidth
      label={label}
      variant="outlined"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
          </InputAdornment>
        ),
      }}
      sx={{ mb: 3 }} // Margem inferior para espaçamento
    />
  );
}

export default FilterField;
